import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './LoaderBar.scss';

var LoaderBar = /*#__PURE__*/function (_Component) {
  _inherits(LoaderBar, _Component);

  var _super = _createSuper(LoaderBar);

  function LoaderBar() {
    _classCallCheck(this, LoaderBar);

    return _super.apply(this, arguments);
  }

  _createClass(LoaderBar, [{
    key: "render",
    value: function render() {
      var style = this.props.center ? {
        position: 'absolute',
        left: '50%',
        top: 10,
        transform: 'translateX(-50%)',
        width: this.props.width
      } : {
        width: this.props.width
      };
      var newStyle = Object.assign({}, style, this.props.style);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.loader,
        style: style
      });
    }
  }]);

  return LoaderBar;
}(Component);

_defineProperty(LoaderBar, "propTypes", {
  center: PropTypes.bool,
  width: PropTypes.any
});

_defineProperty(LoaderBar, "defaultProps", {
  center: false,
  width: '100%'
});

export default LoaderBar;